"use client";
import { cva as e } from "class-variance-authority";
const t = e(
  ["max-h-screen max-w-screen relative", "grow-[5] mx-auto justify-self-center text-left"],
  {
    variants: {
      size: {
        default: [
          "grow-0 justify-self-center self-center",
          "m-auto max-h-[100vw] max-w-screen",
          "md:w-[min(600px,100%)] md:h-[min(760px,100%)]",
          "lg:w-[min(640px,100%)] lg:h-[min(800px,100%)]",
          "2xl:w-[min(760px,100%)] 2xl:h-[min(900px,100%)]"
        ],
        expand: ["w-full h-full"],
        "shrink-vertically": ["w-full h-auto self-start max-h-full"],
        "full-viewport": ["fixed top-0 left-0 w-screen h-screen z-dropdown"]
      },
      variant: {
        "container-with-shadow": "shadow-[0_25px_50px_-12px_rgba(0,0,0,0.25)] dark:shadow-[none]",
        "no-shadow": "shadow-[none]"
      }
    },
    defaultVariants: {
      size: "default",
      variant: "container-with-shadow"
    }
  }
);
export {
  t as aiChatPageWrapper
};
